import { render, staticRenderFns } from "./Xiaomi12tImage4.vue?vue&type=template&id=44a1cd01&scoped=true&"
import script from "./Xiaomi12tImage4.vue?vue&type=script&lang=js&"
export * from "./Xiaomi12tImage4.vue?vue&type=script&lang=js&"
import style0 from "./Xiaomi12tImage4.vue?vue&type=style&index=0&id=44a1cd01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1cd01",
  null
  
)

export default component.exports